'use client'

import { Button, Carousel, Dialog, Icon, Image, Navigation } from '@vinted/web-ui'
import { X24 } from '@vinted/monochrome-icons'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

type Props = {
  slide: number | null
  photos: ReadonlyArray<{ url: string; id: number }>
  onClose: () => void
  onSlideInteract: (slide: number) => void
}

const PhotosDialog = ({ slide, photos, onClose, onSlideInteract }: Props) => {
  const translate = useTranslate()

  const show = slide !== null

  return (
    <Dialog
      show={show}
      closeOnOverlay
      enableCloseButton
      a11yCloseIconTitle={translate('common.a11y.actions.dialog_close')}
      defaultCallback={onClose}
      testId="photos-dialog"
    >
      <Navigation
        right={
          <Button
            icon={<Icon name={X24} title="Close" />}
            inline
            onClick={onClose}
            styling="flat"
          />
        }
        theme="transparent"
      />
      <Carousel
        slides={photos.map(photo => (
          <div
            className="u-flexbox u-justify-content-center u-fill-height u-fill-width"
            key={photo.id}
          >
            <Image src={photo.url} scaling="contain" draggable={false} />
          </div>
        ))}
        index={slide ?? 0}
        onSlideInteract={onSlideInteract}
        styling="floating"
        arrows={photos.length > 1 ? 'inside' : 'hidden'}
        isInfinite
      />
    </Dialog>
  )
}

export default PhotosDialog
